import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  'http-basic': {
    id: 'studio.8eYILH',
    defaultMessage: 'HTTP basic authentication',
  },
  'client-certificate': {
    id: 'studio.dKK3KZ',
    defaultMessage: 'Client certificate authentication',
  },
  'client-credentials': {
    id: 'studio.KFRoYn',
    defaultMessage: 'OAuth client credentials',
  },
  cookie: {
    id: 'studio.XVpEX+',
    defaultMessage: 'Cookie authentication',
  },
  'custom-header': {
    id: 'studio.zVajF8',
    defaultMessage: 'Header based authentication',
  },
  'query-parameter': {
    id: 'studio.rWPtv+',
    defaultMessage: 'Query parameter',
  },
  tokenError: {
    id: 'studio.twPhRk',
    defaultMessage: 'Token request failed on {date}: {error}',
  },
});
